import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const BackgroundSet = ApplicationRecord.extend({
  static: {
    jsonapiType: 'background_sets',
  },
  attrs: {
    defaultBackgroundId: attr(),
    name: attr(),
    backgrounds: hasMany(),
    package: hasMany(),
    defaultBackground: belongsTo(),
  },
})

export default BackgroundSet
